export const mockTemplatesPerPage = 10;

export const MOCKS_CACHE_TTL = 5 * 60 * 1000;

export const STUDENTS_PER_PAGE = 10;

export const statusTabs = [
  { key: "enabled", label: "Habilitados" },
  { key: "draft", label: "Rascunhos" },
  { key: "disabled", label: "Desabilitados" },
];

export const defaultForm = {
  id: null,
  name: "",
  courseId: "",
  courseName: "",
  enabled: true,
  questions: [],
  availabilityMode: "all",
  sendToAll: true,
  studentIds: [],
  studentNames: {},
  triggerLevelId: "",
  triggerLevelName: "",
  notifyStudents: true,
  draft: false,
  linkStudents: [],
};

export const difficultyOptions = [
  { value: "easy", label: "Fácil" },
  { value: "medium", label: "Médio" },
  { value: "hard", label: "Difícil" },
];

export const cognitiveOptions = [
  { value: "understand", label: "Compreender" },
  { value: "apply", label: "Aplicar" },
  { value: "analyze", label: "Analisar" },
];

export const formatOptions = [
  { value: "multiple_choice", label: "Múltipla Escolha" },
  { value: "case", label: "Case" },
];

export const typeTagFilterOptions = [
  { value: "no_calc", label: "Sem cálculo" },
  { value: "interactive", label: "Questão interativa" },
  { value: "case", label: "Case" },
  { value: "calc", label: "Com cálculo" },
  { value: "recurring", label: "Recorrente" },
];

export const recentFilterOptions = [
  { value: "1_week", label: "Criadas essa semana" },
  { value: "1_month", label: "Criadas esse mês" },
  { value: "3_months", label: "Criadas até 3 meses" },
  { value: "6_months", label: "Criadas até 6 meses" },
];

export const advancedBooleanFilters = [
  {
    field: "aiGeneratedEq",
    label: "Geradas por IA",
    options: [
      { value: "true", label: "Apenas Questões Geradas por IA" },
      { value: "false", label: "Apenas Questões não Geradas por IA" },
    ],
  },
  {
    field: "calcRequiredEq",
    label: "Requerem Cálculo",
    options: [
      { value: "true", label: "Apenas Questões que Requerem Cálculo" },
      { value: "false", label: "Apenas Questões que Não Requerem Cálculo" },
    ],
  },
  {
    field: "highlightedEq",
    label: "Recorrentes",
    options: [
      { value: "true", label: "Apenas Questões Recorrentes" },
      { value: "false", label: "Apenas Questões não Recorrentes" },
    ],
  },
  {
    field: "showInLessonQuizEq",
    label: "Exibidas no Quiz",
    options: [
      { value: "true", label: "Apenas Questões Exibidas no Quiz" },
      { value: "false", label: "Apenas Questões não Exibidas no Quiz" },
    ],
  },
  {
    field: "reviewedAtNull",
    label: "Revisão",
    options: [
      { value: "false", label: "Apenas Questões Revisadas" },
      { value: "true", label: "Apenas Questões não Revisadas" },
    ],
  },
  {
    field: "commentVideoUrlOrCommentTextOrCommentFilePresent",
    label: "Comentário (Vídeo, Texto ou Áudio)",
    options: [
      { value: "true", label: "Apenas Questões com Comentário" },
      { value: "false", label: "Apenas Questões sem Comentário" },
    ],
  },
  {
    field: "commentVideoUrlPresent",
    label: "Comentário em Vídeo",
    options: [
      { value: "true", label: "Apenas Questões com Vídeo" },
      { value: "false", label: "Apenas Questões sem o Vídeo" },
    ],
  },
  {
    field: "commentTextPresent",
    label: "Comentário em Texto",
    options: [
      { value: "true", label: "Apenas Questões com Texto" },
      { value: "false", label: "Apenas Questões sem o Texto" },
    ],
  },
  {
    field: "commentFilePresent",
    label: "Comentário em Áudio",
    options: [
      { value: "true", label: "Apenas Questões com Áudio" },
      { value: "false", label: "Apenas Questões sem o Áudio" },
    ],
  },
];

export const questionDefaultFilters = (courseId) => ({
  idEq: "",
  contextOrTagsNameCont: "",
  contextCont: "",
  lessonsCourseIdIn: courseId ? [Number(courseId)] : [],
  fromLevelsExpanded: [],
  difficultyLevelIn: [],
  cognitiveLevelIn: [],
  statusIn: ["approved"],
  typeTagsIn: [],
  formatEq: "",
  aiGeneratedEq: "",
  calcRequiredEq: "",
  highlightedEq: "",
  showInLessonQuizEq: "",
  teacherIdEq: "",
  reviewerIdEq: "",
  tagsNameIn: "",
  teacherNotesCont: "",
  commentVideoUrlPresent: "",
  commentTextPresent: "",
  commentFilePresent: "",
  commentVideoUrlOrCommentTextOrCommentFilePresent: "",
  reviewedAtNull: "",
  recentFilter: "",
  s: "id desc",
});

export const difficultyMap = { easy: 1, medium: 2, hard: 3 };
export const cognitiveMap = { understand: 1, apply: 2, analyze: 3 };
export const formatMap = { multiple_choice: 1, case: 2 };

export const difficultyLabels = difficultyOptions.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});
export const cognitiveLabels = cognitiveOptions.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});
export const formatLabels = formatOptions.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});
